import { Button } from 'antd';
import styled from 'styled-components';
export const DownloadButton = styled(Button)`
  color: #98a9bc;
  border-color: #98a9bc;
  padding: 0px 12px;
  margin-right: 10px;
`;